import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

const PrivateRoute = ({ roles, rootAccess = false }) => {
  const state = useSelector((state) => state.auth);


  const roleChecker = () => {
    if (state?.isLoggedIn) {
      if (rootAccess) return true;

      if (roles.includes(state?.current?.user?.role)) return true;
    }
    return false;
  };

  return roleChecker() ? <Outlet /> : <Navigate to={"/login"} replace />;
};

export default PrivateRoute;
